
//Représente les paramètres de rapprochement des commandes aux factures d’achat
export class AeFRapprocherCommandesFacturesAchatParametres 
{
  //Identifiant de la session
  public identifiantSession!: string;

  //Identifiants des factures
  public identifiantsFactures!: string[];
}

//Représente le résultat du rapprochement des commandes aux factures d’achat
export class AeFRapprocherCommandesFacturesAchatResultat 
{
  //Nombre de facture rapprochées
  public nombreFactureRapprochees!: number;

  //Nombre de facture rejetées
  public nombreFactureRejetees!: number;

  //Références de commandes des factures
  public commandesFactures!: AeFCommandeFacture[];
}

//Représente une référence de commande d’une facture
export class AeFCommandeFacture 
{
  //Identifiant de la facture
  public identifiantFacture!: string;

  //Référence de commande
  public referenceCommande!: string;
}
